// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Col, Row, List } from 'antd'
import classnames from 'classnames'
import dongleOnlineImg from 'assets/images/dongle_online.png'
import dongleOfflineImg from 'assets/images/dongle_offline.png'
import cameraImage from 'assets/images/camera.svg'
import Icon from '@ant-design/icons'
import { UploadOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { MultipleSelectionModel } from '../../utils/multiple-selection-model'


//const DeviceIcon = props => <Icon component={DeviceIconSvg} style={{ fontSize: '40px'}} {...props} />

export interface IDeviceListItemProps {
  item: any
  handleClick: (deviceID: string) => void
}

export interface IDeviceListItemState {

}

const onlineCameraImage = <img src={cameraImage}/>

export class DeviceListItem extends React.Component<IDeviceListItemProps, IDeviceListItemState> {
  constructor (props) {
    super(props)
    this.state = {
      //isSelected: props.selectionModel.isSelected(props.index)
    }
  }

  componentDidMount () {

  }

  componentWillUnmount () {

  }


  handleDeviceClick = (deviceID) => {
    const { handleClick } = this.props
    handleClick(deviceID)
  }

  render () {
    const { item } = this.props
    const classname = classnames('camera-finder-list-item', {
      //selected: this.state.isSelected
    })
    return (
      <List.Item className={classname} onClick={()=>this.handleDeviceClick(item.deviceID)}>
        <List.Item.Meta
          avatar={<img src={item.onlineStatus==1 ? dongleOnlineImg:dongleOfflineImg} style={{width: "50px"}}/>}
          title={
            <Row justify='space-between' align='middle'>
                <Col>{item.deviceID}</Col>
                <Col><UploadOutlined onClick={()=>{console.log("click upload")}} style={{cursor: "pointer"}}/></Col>
            </Row>
          }
          description={
            <Row justify='space-between' align='middle'>
                <Col>
                    <ClockCircleOutlined />&nbsp;{item.createdAt}
                </Col>
            </Row>
          }
        />
      </List.Item>
    )
  }
}
